import { Injectable } from "@angular/core";
import { CustomerFormService } from "./customer-form.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  BusinessCustomerWithCustomerDetails,
  BuyingOfferSettings,
  Customer,
  OverviewUserBuyingOffer, OverviewUserViewingPass,
  ViewingPassSettings
} from "@frontend/models";

@Injectable({ providedIn: 'root' })
export class ViewingPassFormService {

  constructor(
    private readonly _customerFormService: CustomerFormService,
    private readonly _fb: FormBuilder
  ) { }

  createViewingPassFormGroup(
    businessCustomer: BusinessCustomerWithCustomerDetails | null,
    customers: Customer[],
    viewingPassSettings: ViewingPassSettings,
    overviewUserViewingPass?: OverviewUserViewingPass,
  ): FormGroup {
    const isBusinessCustomer = !!businessCustomer;

    const customersFormArray = this._fb.array(customers.map(c =>
      this._customerFormService.convertToFormGroup(c)
    ));

    let businessCustomerFormGroup = this._fb.group({});
    if (isBusinessCustomer) {
      businessCustomerFormGroup = this._customerFormService.createBusinessCustomerFormGroup();

      businessCustomerFormGroup.patchValue(businessCustomer);
    }

    const detailsFormGroup = this._fb.group({
      viewingDate: [overviewUserViewingPass?.viewingDate ?? null, Validators.required],
      offersAgreement: [overviewUserViewingPass?.offersAgreement ?? false],
      agreedToNewsletter: [overviewUserViewingPass?.offersAgreement ?? false],
      agreedToSurvey: [overviewUserViewingPass?.offersAgreement ?? false],
      agreedToDataTransmissionToFranchise: [overviewUserViewingPass?.agreedToDataTransmissionToFranchise ?? false],
      instructedCancellationConditions: [overviewUserViewingPass?.instructedCancellationConditions ?? false],
      agentCanTakeActionBeforeCancellationPeriod: [overviewUserViewingPass?.agentCanTakeActionBeforeCancellationPeriod ?? false],
    });

    return this._fb.group({
      customers: customersFormArray,
      businessCustomer: businessCustomerFormGroup,
      details: detailsFormGroup,
    });
  }

}